import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from '../components/mensajes';
import { Loader, Dimmer } from 'semantic-ui-react';

const CatalogoSErviDescrip = (props) => {

    const btnAcepta = useRef();
    const btnCancela = useRef();
    const txtDescripcion = useRef();
    const [mensaje, setMensaje] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [activate, setActivate] = useState(false);

    const blanquear = () => {
        setActivate(false);
    };

    const cancelar = () => {
        blanquear();
        props.onHideAceptaCatalogo(null);
    };

    const seleccionarCliente = () => {
        props.onHideAceptaCatalogo(txtDescripcion.current.value.trim());
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                blanquear();
                txtDescripcion.current.focus();
            }}
        >
            <Modal.Header className="azulGradiant2 header-modal">
                <div className="fw-bold text-light">
                    <h3>Descripción del Servicio</h3>
                </div>
                <button
                    ref={btnCancela}
                    className="bg-transparent"
                    style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
                    onClick={cancelar}
                >
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje
                    mensaje={mensaje}
                    onHide={() =>
                        setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
                    }
                />
                <Dimmer active={activate} inverted>
                    <Loader inverted>Cargando...</Loader>
                </Dimmer>
                <div className="col-md-12" style={{ margin: "auto" }}>
                    <div className="col-md-12 mx-auto row mb-1 py-2 border-azul rounded ">
                        <div className="input-group input-group-sm mb-2 col-md-12">
                            <label
                                className="input-group-text"
                                id="inputGroup-sizing-sm"
                            >
                                DESCRIPCION:{" "}
                            </label>
                            <textarea
                                autoComplete="off"
                                type="text"
                                ref={txtDescripcion}
                                className="form-control fs-6 text-uppercase"
                                style={{ height: 50 }}
                                aria-label="Sizing example input"
                                aria-describedby="inputGroup-sizing-sm"
                            />
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button
                    ref={btnAcepta}
                    className="btn btn-sm btn-success rounded-pill"
                    style={{ margin: "5px" }}
                    onClick={seleccionarCliente}
                >
                    <i className="fas fa-check-circle"> Aceptar</i>{" "}
                </button>
                <button
                    ref={btnCancela}
                    onClick={cancelar}
                    className="btn btn-sm btn-danger rounded-pill"
                >
                    <i className="fas fa-window-close"> Cancelar</i>
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default CatalogoSErviDescrip;


// WEBPACK FOOTER //
// ./src/catalogos/catalogo_servi.js